<template>
    <div>
        <div class="page-wrapper">
            <div class="page-bg"></div>
            <div class="page-content">
                <TopBarDark
                    :title="lbl.verify_birthday.title"
                    @clickBack="clickBack()">
                </TopBarDark>
                <div class="verify-page">
                    <div class="wrapper-verify">
                        <div class="wrapper-logo">
                            <img src="@/assets/logo/navbar_logo_naos@2x.svg" class="img-fluid m-auto">
                            <img src="@/assets/logo/navbar_logo_bio@3x.png" class="m-auto img-text" alt="">
                        </div>
                        <div>
                            <div class="text-detail">{{ lbl.verify_birthday.msg }}</div>
                            <div>
                                <DropdownDatePicker
                                    v-model="date"
                                    :formId="'birthDate'"
                                    :inputLbl="lbl.verify_birthday.birthdate"
                                    :isFirstSave="isFirstSave"
                                    :isShowErrorLbl="isShowErrorLbl"
                                    :errorInfo="errorInfo[0]"
                                    @onDateChange="onDatePickerSelected($event)"
                                ></DropdownDatePicker>
                            </div>
                        </div>
                        <div class="btn-submit" @click="clickSubmit()" v-if="birthDate != null">
                            <div class="btn-txt">
                                {{lbl.default.confirm}}
                            </div>
                        </div>
                        <div class="btn-submit disabled" v-else>
                        <div class="btn-txt">
                            {{lbl.default.confirm}}
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
//helper
import Account from "@/helper/AccountHelper.js";
import FormHelper from '@/helper/FormHelper.js';
// import LineFunction from "@/helper/facade/LineFunction.js";
import CacheHelper from "@/helper/CacheHelper.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//component
import TopBarDark from "@/components/Layout/TopBarPage/TopBarDark.vue"
import DropdownDatePicker from '@/components/Input/DropdownDatePicker.vue';
//service 
import RegisterApi from "@/core/Bioderma/service/RegisterApi.js";
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";
export default {
    name: 'Terms',
    components: {
        TopBarDark,
        DropdownDatePicker
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            profile: Account.getCacheProfile(),
            isLogin: false,

            errorInfo: [],
            isShowErrorLbl: true,
            isFirstSave: true,
            birthDate: null,
            date: null,
            otp: null,
            contactNumber: '',
            cache: new CacheHelper('local'),
            cacheSession: new CacheHelper('session'),
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(1);
        
    },
    methods: {
        clickBack: function () {
            this.$router.back();
        },
        onDatePickerSelected: function(obj) {
            this.date = obj.datetime;
            this.birthDate = obj.timestamp
            console.log(obj);
        },
        clickSubmit: async function () {
            //get otp
            this.contactNumber = this.cache.getCache('contact_change_line');
            console.log(this.contactNumber);
            
            this.otpModal.startOtp(this.contactNumber, 'change_line');
            this.otpModal.onSubmitOtp(async data =>  {
                console.log('success',data);
                this.textError = '';
                let validateCode = await this.apiValidateOtp(data);
                this.apiChangeLine(data, validateCode);
                this.cache.removeCache('contact_change_line');
            });
            //error
            this.otpModal.onError((err) =>{
                console.log('err', err);
                if(err.id == 2078){
                    this.textError = 'ขออภัยค่ะ เบอร์โทรศัพท์ของท่านมีอยู่แล้วในระบบ';
                    this.alertModal
                        .setMsg(this.textError)
                        .setTheme('gray')
                        .show();
                } else {
                    this.errorApi(err);
                }
            });
            //success
            this.otpModal.onSuccess(() =>{
                this.textError = '';
            });
        },
        apiValidateOtp: async function(data) {
            return new Promise((resolve, reject) => {
                BzbsOtp.validateOtp(this.contactNumber, data.refcode, data.otp, 'change_line', '', false).subscribe((data) => {
                    console.log(data);
                    // this.refcode = data.refcode;
                    resolve(data.validatecode);
                }, (err) => {
                    if (err.id == 2078) {
                        this.alertModal
                            .setMsg(err.message)
                            .setTheme('gray')
                            .show();
                    } else {
                        this.errorApi(err);
                    }

                    reject(false);
                });
            });
        },
        apiChangeLine: function(data, validateCode){
            let lineIdToken = this.cacheSession.getCache('LineIdToken');
            
            var otpModel = {
                otp: data.otp,
                refcode: data.refcode,
                validateCode: validateCode,
            }
           
            RegisterApi.apiChangeLine(lineIdToken, this.contactNumber, otpModel, this.birthDate).subscribe((res) =>{
                console.log("check",res);
                if(!res.success){
                    this.modalError(res.code);
                }else{
                    window.location.replace('/linelogin')
                }
                this.otpModal.hide();
                // window.location.replace('/linelogin')

            },(err) => {
                this.loadingModal.hide();
                console.log(err);
                this.modalError(err.code);
                this.otpModal.hide();
                // this.errorApi(err);
            });
        },
        modalError: function(code) {
            let err = `${this.lbl.verify_birthday.modal_error.error} ${code}`;
            this.confirmModal
                .setTitle(this.lbl.verify_birthday.modal_error.title)
                .setError(err)
                .setMsg(this.lbl.verify_birthday.modal_error.msg)
                .setBtnOk(this.lbl.verify_birthday.modal_error.btn_ok)
                .setBtnCancel(this.lbl.verify_birthday.modal_error.btn_cancel)
                .setTag('verify_birthday')
                .seIconError()
                .show();
            this.confirmModal.onClickOk(() => {
                window.location.href = this.lbl.verify_birthday.modal_error.line
            });
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/input/BaseButton.scss";
.page-wrapper {
    .page-bg {
        background-color: $white;
    }
}
.verify-page {
    position: relative;
    .wrapper-verify {
        @include bg-curve();
        height: calc(100vh - 100px);
        position: absolute;
        bottom: unset;
        padding: 20px 10px 10px;
        .wrapper-logo {
            margin: auto;
            display: flex;
            flex-direction: column;
            gap: 10px;
            .img-text {
                width: 218px;
            }
        }
        
        .text-detail {
            font-size: 1rem;
            text-align: center;
            font-weight: 700;
            color: $deep-blue;
            margin-top: 40px;
        }
        .btn-submit{
            position: fixed;
            bottom: 40px;
            left: 0;
            right: 0;
            width: 85% !important;
            @include btn-wrapper();

            &:disabled {
                opacity: 0.3;
            }
        }
    }
}

</style>
